export const extractFileName = (labelUrl: string) => labelUrl.substring(labelUrl.lastIndexOf('/') + 1);

export const extractShipmentReportFileName = (reportUrl: string) => reportUrl.split('?file=')[1];

export const changeFileExtension = (fileName: string, newExtension: string) =>
  fileName.substring(0, fileName.lastIndexOf('.')) + `${newExtension}`;
